<template lang="pug">
div
  .h-vertical-align-container(v-if="modalShow")
      .modal__close(@click='overlay()')
      .modal__overlay(@click='overlay()')
      .videoModal__wrapper
        .fluid__video#fluid__video--tutorial(v-html='ytVideo') {{ytVideo}}

  section.full__video
    .intro__content.intro__content--mobile
      img.lazy#productLogo(data-srcset='https://cdn.flixel.com/static/static-web/products/mac/cinemagraphpro@2x.png 2x, https://cdn.flixel.com/static/static-web/products/mac/cinemagraphpro.png 1x')
      h2 Cinemagraphs Made Easy
      .btn__group.btn__group--splash
        download-trial-button(
          product='pro',
          classes='btn btn--purpleLight btn__splash',
          copy='Download free trial')
        get-plan(
          classes='btn btn--white'
        )
    .fluid__video
      .intro__content.intro__content--desktop
        img.lazy#productLogo(data-srcset='https://cdn.flixel.com/static/static-web/products/mac/cinemagraphpro@2x.png 2x, https://cdn.flixel.com/static/static-web/products/mac/cinemagraphpro.png 1x')
        h2 Cinemagraphs Made Easy
        .btn__group
          download-trial-button(
            product='pro',
            classes='btn btn--purpleLight',
            copy='Download free trial')
          get-plan
      iframe(data-src='https://media.flixel.com/cinemagraph/fuj1qc9uytw18p3rm6xx?hd=true' allow='autoplay')
      .credit
        a(target='_blank' href='https://flixel.com/JonathanH/') JonathanH

  brands

  section
    .product__section
      .product__section--container
        .product__section--content
          .productItem__title
            img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/products/mac/icons/cinemagraph-pro-icon@2x.png 2x, https://cdn.flixel.com/static/static-web/products/mac/icons/cinemagraph-pro-icon.png 1x')
            h2
              | Cinemagraph Pro
              span for macOS
          .productItem__desc
            p Create stunning cinemagraphs easily and faster with the 2014 Apple Design Award Winner Cinemagraph Pro for macOS.

            .btn__group
              download-trial-button(
                product='pro',
                classes='btn btn--purpleLight',
                copy='Download free trial')
              get-plan
          img.lazy#designaward(data-srcset='https://cdn.flixel.com/static/static-web/awards/awardada@2x.png 2x ,https://cdn.flixel.com/static/static-web/awards/awardada.png 1x')
        .product__section--cinemagraph.cpCinemagraph
          .fluid__video
            iframe(data-src='https://media.flixel.com/cinemagraph/0ryeqmkxv7xgqxdwdgt2?hd=false')

  section
    .product__section.product__section--features
      .features__text
        h2 Transform Your Visual Storytelling
        p Cinemagraph Pro enables creators to redefine their visual storytelling across photography, social media and digital advertising using cinemagraphs. With advanced features and a simplified process, Cinemagraph Pro makes cinemagraph creation fun, fast and easy.
        download-trial-button(
          product='pro',
          classes='btn btn--purpleLight ',
          copy='Download free trial')

      .product__section--grid
        .grid__item
          .grid__item--pic
            img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/products/mac/grid/cinemagraph-pro-1@2x.png 2x, https://cdn.flixel.com/static/static-web/products/mac/grid/cinemagraph-pro-1.png 1x')
          .grid__item--title
            h3 Start With High Quality Video
          .grid__item--desc
            p Cinemagraphs created in Cinemagraph Pro for macOS are based in video. The video quality that you import, is the video quality that you export. Shoot, edit and export cinemagraphs created with high quality footage, including 4K video, to tell the most vivid stories possible.
        .grid__item
          .grid__item--pic
            img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/products/mac/grid/cinemagraph-pro-2@2x.png 2x, https://cdn.flixel.com/static/static-web/products/mac/grid/cinemagraph-pro-2.png 1x')
          .grid__item--title
            h3 Cinemagraph Creation Simplified
          .grid__item--desc
            p Cinemagraph Pro for macOS is a time-saving tool that brings the entire cinemagraph creation process into one place. Import your video, trim your clip, select your still image and paint over the still image to reveal the motion. Simple, and fast.
        .grid__item
          .grid__item--pic
            img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/products/mac/grid/cinemagraph-pro-3@2x.png 2x, https://cdn.flixel.com/static/static-web/products/mac/grid/cinemagraph-pro-3.png 1x')
          .grid__item--title
            h3 Express Yourself with Colour Adjustments
          .grid__item--desc
            p Define the look of your cinemagraph with advanced tone curve colour adjustments. Use colour correcting, highlights, shadows, temperature and other controls to make your cinemagraph truly your own.
        .grid__item
          .grid__item--pic
            img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/products/mac/grid/cinemagraph-pro-4@2x.png 2x, https://cdn.flixel.com/static/static-web/products/mac/grid/cinemagraph-pro-4.png 1x')
          .grid__item--title
            h3 Style Your Cinemagraphs with Presets
          .grid__item--desc
            p Use one of the many presets available in-app to quickly style your cinemagraphs. Or, create your own presets that you can apply to any cinemagraph so that you can make your mark, and save time.
        .grid__item
          .grid__item--pic
            img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/products/mac/grid/cinemagraph-pro-5@2x.png 2x, https://cdn.flixel.com/static/static-web/products/mac/grid/cinemagraph-pro-5.png 1x')
          .grid__item--title
            h3 Find the Perfect Fit
          .grid__item--desc
            p Cinemagraphs are shared across the web, social media, digital advertising, television, digital displays and more. Use the crop, rotate, flip or straighten tools to create cinemagraphs of all shapes and sizes so that they display perfectly everywhere.
        .grid__item
          .grid__item--pic
            img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/products/mac/grid/cinemagraph-pro-6@2x.png 2x, https://cdn.flixel.com/static/static-web/products/mac/grid/cinemagraph-pro-6.png 1x')
          .grid__item--title
            h3 Easy to Create. Easy to Share.
          .grid__item--desc
            p Export your beautiful cinemagraphs into an MP4 format to instantly share your cinemagraph on social media, in digital advertising and more. Upload your work to your Flixel gallery, from where you can easily embed your cinemagraphs on websites and blogs.

  section
    .product__section.product__section--persecondVideo
      .product__section--video
        a(href='https://www.youtube.com/watch?v=NDDcZvqHoQU' @click='ytModal($event)')
          img.lazy(data-src='https://cdn.flixel.com/static/static-web/home/flixel-video-tour.png')
          .playbtn

  section.product__section.product__section--callout
    .callout__title
      h1 Achieve Perfectly Looped Cinemagraphs
    .callout__text
      p Shoot perfectly still video footage using a digital camera on a tripod. Compose it like a photo with a repeated movement and capture it. Import your video into Cinemagraph Pro for macOS and let the magic begin.
    .btn__group
      download-trial-button(
        product='pro',
        classes='btn btn--purpleLight',
        copy='Download free trial')
      get-plan

  section
    .product__section
      .product__section--container.product__section--reverse.cpProAd
        .product__section--content.cpProAd--content
          .productItem__title
            h3 Cinemagraphs Grow Your Photography Business
          .productItem__desc
            p Photographers need to stay competitive. Cinemagraphs give you new products and services to delight your clients. They’re a premium product that’ll grow your business. Use Cinemagraph Pro to create cinemagraphs that will make your business stand out.
            a.productItem__desc--purpleLink(href='http://blog.flixel.com/how-price-your-cinemagraphs/') Learn How to Price and Sell Cinemagraphs for Your Photography Business >
        .product__section--image
          a(href='https://www.youtube.com/watch?v=11d9y3Xs6Qk' @click='ytModal($event)')
            img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/products/mac/cinemagraphGrow.png')
            .playbtn
  section
    .product__section
      .product__section--container.cpProAd
        .product__section--content.cpProAd--content
          .productItem__title
            h3 Drive Better Campaign Results with Cinemagraphs
          .productItem__desc
            p It is incredibly challenging to capture the attention of online audiences. Cinemagraphs help you engage customers and change your brand storytelling instantly, while delivering superior results compared to still images.
            a.productItem__desc--purpleLink(href='/case-studies/') View Case Studies >
        .product__section--image
          a(href='https://www.youtube.com/watch?v=AdMQFqmJp98' @click='ytModal($event)')
            img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/products/mac/cinemagraphDrive.png')
            .playbtn

  section.flixelPlan__section
    .flixelPlan__container
      h1 Choose a plan that’s right for you
      p Whether you’re a photographer, marketer, or designer, creating cinemagraphs is fun, fast, and easy with Cinemagraph Pro. Select a plan and start using the best cinemagraph creation tools and web-sharing platform.
      .btn__group
        get-plan

  section
    .product__section
      .product__section--specs
        h2 System Requirements
        p macOS 10.12.2 Sierra or later, 4GB of RAM (8GB recommended for 4K), Metal-capable graphics card 
          a(href='https://support.apple.com/en-us/HT205073')
            | (Macs from 2012 or later),
          |  256MB of VRAM (1GB recommended for 4K), 1GB of disk space.
  // Rich Card
  script(
    type="application/ld+json" 
    ) {{ this.$metaInfo}}
</template>

<script>
import Brands from 'components/Brands.vue';
import downloadTrialButton from 'components/downloadTrialButton.vue';
import getPlan from 'components/getPlan.vue';
import productmixin from './productmixin.vue';

export default {
  name: 'mac-fcp',
  metaInfo() {
    return {
      title: 'Cinemagraph Pro for macOS | Flixel',
      meta: [
        {
          'property': 'image',
          'content': 'https://cdn.flixel.com/static/static-web/CinemagraphPromacOS.png',
        },
        {
          'property': 'description',
          'content': 'The best app to create professional cinemagraphs and get noticed. Great for digital advertising, social media, and more using Apple Design Award Winner Cinemagraph Pro for macOS.',
        },
        {
          'property': 'richcard',
          'content': '{"@context":"https://schema.org","@type":"SoftwareApplication","name":"Cinemagraph Pro for macOS","award":["Apple Design Award","Best of the App Store 2014"],"description":"The best app to create professional cinemagraphs and get noticed. Great for digital advertising, social media, and more using Apple Design Award Winner Cinemagraph Pro for macOS.","image":["https://cdn.flixel.com/static/static-web/CinemagraphPromacOS_1_1.png","https://cdn.flixel.com/static/static-web/CinemagraphPromacOS_4_3.png","https://cdn.flixel.com/static/static-web/CinemagraphPromacOS_16_9.png"],"downloadUrl":"https://flixel.com/products/mac/pro/download/","operatingSystem":"macOS 10.12.2 and higher","storageRequirements":"500 MB","applicationCategory":"https://schema.org/SoftwareApplication","aggregateRating":{"@type":"AggregateRating","ratingValue":"4.8","bestRating":"5.0","ratingCount":"5301"},"offers":{"@type":"Offer","price":"29.99","priceCurrency":"USD"}}',
        },
      ],
      script: [
        {
          innerHTML: '{"@context":"https://schema.org","@type":"SoftwareApplication","name":"Cinemagraph Pro for macOS","award":["Apple Design Award","Best of the App Store 2014"],"description":"The best app to create professional cinemagraphs and get noticed. Great for digital advertising, social media, and more using Apple Design Award Winner Cinemagraph Pro for macOS.","image":["https://cdn.flixel.com/static/static-web/CinemagraphPromacOS_1_1.png","https://cdn.flixel.com/static/static-web/CinemagraphPromacOS_4_3.png","https://cdn.flixel.com/static/static-web/CinemagraphPromacOS_16_9.png"],"downloadUrl":"https://flixel.com/products/mac/pro/download/","operatingSystem":"macOS 10.12.2 and higher","storageRequirements":"500 MB","applicationCategory":"https://schema.org/SoftwareApplication","aggregateRating":{"@type":"AggregateRating","ratingValue":"4.8","bestRating":"5.0","ratingCount":"5301"},"offers":{"@type":"Offer","price":"29.99","priceCurrency":"USD"}}',
          type: 'application/ld+json',
        },
      ],
    };
  },
  data() {
    return {
      modalShow: false,
      ytVideo: '',
      modalProduct: false,
    };
  },
  mounted() {
    $(window).ready(function () {
      $(window).scrollTop(0);
    });
  },
  methods: {
    ytModal($event) {
      $event.preventDefault();
      const ytURL = $event.currentTarget.getAttribute('href');
      const iframeURL = ytURL.split('v=')[1];
      const videoHeight = window.innerHeight - 200;
      const videoWidth = window.innerWidth - 200;

      this.modalShow = true;
      $('body').bind('touchmove', function (e) {
        e.preventDefault();
      });
      this.ytVideo = '<iframe height=' + videoHeight + ' width= ' + videoWidth + ' src="https://www.youtube.com/embed/' + iframeURL + '?rel=0&amp;autoplay=1" frameborder="0" allowfullscreen></iframe>';
    },
    overlay() {
      $('body').unbind('touchmove');
      this.modalShow = false;
      this.modalProduct = false;
    },
  },
  mixins: [productmixin],
  components: {
    'Brands': Brands,
    'download-trial-button': downloadTrialButton,
    'getPlan': getPlan,
  },
};
</script>


// WEBPACK FOOTER //
// src/views/products/mac-fcp.vue